<template>
  <div
    v-if="urlRessourceEndPoint"
    class="cx-filtre-gestion-crm-container"
  >
    <div class="cx-filtre-gestion-crm-ligne">
      <fx-label
        text="Affichage"
        width="80px"
      />
      <fx-dropdown
        v-model="selectedAffichage"
        :data-provider.sync="dataAffichage"
        :url="urlRessourceEndPoint + 'affichage'"
        @on-change="filterChanged"
      />
    </div>
    <div class="cx-filtre-gestion-crm-ligne">
      <fx-label
        text="Commercial"
        width="80px"
      />
      <fx-dropdown
        v-model="selectedCommercial"
        :data-provider.sync="dataCommerciaux"
        :url="urlRessourceEndPoint + 'commerciaux'"
        @on-change="filterChanged"
      />
    </div>
    <div class="cx-filtre-gestion-crm-ligne">
      <fx-label
        text="Secteur"
        width="80px"
      />
      <fx-dropdown
        v-model="selectedSecteur"
        :data-provider.sync="dataSecteurs"
        :url="urlRessourceEndPoint + 'secteurs'"
        @on-change="filterChanged"
      />
    </div>
    <div class="cx-filtre-gestion-crm-ligne">
      <fx-label
        text="Etat"
        width="80px"
      />
      <fx-dropdown
        v-model="selectedEtat"
        :data-provider.sync="dataEtats"
        :url="urlRessourceEndPoint + 'etats'"
        @on-change="filterChanged"
      />
    </div>
    <div>
      <fx-checkbox
        v-model="selectedFiltreAction"
        label="Filtrer les actions"
        @on-change="filterChanged"
      />
    </div>
  </div>
</template>
<script>

import FxFiltreTemplate from '@/wikaz-core/ui/composants/base/FxFiltreTemplate'

export default {
    name: 'CxFiltreGestionCrm',
    extends: FxFiltreTemplate,
    data () {
        return {
            urlRessourceEndPoint: null,
            isMyProspect: 1,
            selectedCommercial: this.$store.state.user.id,
            dataCommerciaux: null,
            selectedSecteur: 0,
            dataSecteurs: null,
            selectedEtat: 0,
            dataEtats: null,
            selectedFiltreAction: 0,
            dataAffichage: null,
            selectedAffichage: 1,
        }
    },
    mounted () {
        switch (process.env.VUE_APP_CLIENT_ID) {
        case '4':
            this.urlRessourceEndPoint = 'api/crm/modules/gestion-prospects-crm/'
            break
        case '5':
            this.urlRessourceEndPoint = 'api/entreprises/modules/gestion-prospects-wk-crm/'
            break
        }
    },
    methods: {
        getFiltreData () {
            return '?commercial=' + this.selectedCommercial + '&secteur=' + this.selectedSecteur + '&etat=' + this.selectedEtat + '&action=' + this.selectedFiltreAction + '&affichage=' + this.selectedAffichage
        },
    },
}
</script>
<style scoped lang="scss">
    .cx-filtre-gestion-crm-container {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto auto auto auto;
        overflow: auto;
    }

    .cx-filtre-gestion-crm-ligne {
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 80px 1fr;
        grid-template-rows: 1fr;
    }
</style>